import wretch from 'wretch';
import AbortAddon from 'wretch/addons/abort';
import QueryStringAddon from 'wretch/addons/queryString';

import logToDatadog from '@/logger/logToDatadog';

const fetchClient = wretch.bind([AbortAddon, QueryStringAddon]);

export const nextBackendClient = fetchClient('', { mode: 'cors' })
  .errorType('json')
  .resolve((r) => r.json())
  .catcherFallback((error) => {
    logToDatadog({
      error,
      message: 'Uncaught Next Backend Client error',
      module: 'app',
    });
  });
